import jwt from 'jsonwebtoken';
import moment from 'moment';
import numeral from 'numeral';
import 'numeral/locales';
numeral.locale( 'pt-br' );

export const allStatus = props => {
	return props.map( e => ( {
		...e,
		name     : e.status,
		selected : false,
		checked  : false
	} ) );
};

export const allTasks = props => {
	let task = [];

	props.dealStatusList.map( e =>
		task.push( { ...e, name: e.task, selected: false, checked: false } )
	);

	// Filtra tarefas vazias, null ou undefined e exclui "Enviar Email"
	const filteredTasks = task.filter( t => {
		const taskName = t.task?.trim().toLowerCase();
		return (
			t.task &&
			t.task.trim() !== '' &&
			taskName !== 'enviar e-mail'
		);
	} );

	const idsSt = [ ...new Set( filteredTasks.map( x => x.task ) ) ];
	const tasks = idsSt.map( k => filteredTasks.filter( b => b.task === k ).pop() );

	return tasks;
};

export const allClient = props => {

	const clientsMap = props.clients?.data || props.clients;
	let client = [];

	clientsMap.map( e => client.push( { name: e.name, id: e.id, tenant_id: e.tenant_id } ) );

	const name = [ ...new Set( client.map( x => x.name ) ) ];
	return name
		.sort( ( a, b ) => a.localeCompare( b ) )
		.map( k => client.filter( b => b.name === k ).pop() );
};

export const allSubClient = props => {
	let subClient = [];
	props.subClients.map( e => subClient.push( { id: e.id, name: e.name, clientId: e.client_id } ) );

	return subClient
		.sort( ( a, b ) => a.name.localeCompare( b.name ) );
};

export const allGroups = props => {
	let group = [];
	props.groups.map( e => group.push( { id: e.id, name: e.name, sub_client_id: e.sub_client_id, negotiateInAf: e.negotiateInAf } ) );

	return group
		.sort( ( a, b ) => a.name.localeCompare( b.name ) );
};
export const allNegotiators = props => {
	return props.map( e => ( { id: e.id, name: e.email, email: e.email, client_id: e.client_id, tenant_id: e.tenant_id } ) );
};

export const allSubClientDashboard = props => {
	let client = [];
	props.subClients.map( e => client.push( { name: e.name, clientId: e.sub_client.client_id } ) );

	const name = [ ...new Set( client.map( x => x.name ) ) ];
	return name
		.sort( ( a, b ) => a.localeCompare( b ) )
		.map( k => client.filter( b => b.name === k ).pop() );
};

export const formatDate = d => {
	return moment( d, 'YYYY-MM-DD' ).format( 'YYYY-MM-DD' );
};

export const formatDatePt = d => {
	return moment( d, 'DD/MM/YYYY' ).format( 'YYYY-MM-DD' );
};

export const getIconsTask = e => {
	switch ( e.toLowerCase().trim() ) {
	case 'pegar contato':
		return { bg: '#fff', icon: { name: 'ImportContacts', bg: '#05aecc' } };
	case 'pegar dados':
		return { bg: '#fff', icon: { name: 'ImportContacts', bg: '#05aecc' } };
	case 'tratar contraproposta':
		return { bg: '#fff', icon: { name: 'MailOutlined', bg: '#ff9f19' } };
	case 'tratar whatsapp':
		return { bg: '#fff', icon: { name: 'WhatsApp', bg: '#0cb969' } };
	case 'assinar minuta':
		return { bg: '#fff', icon: { name: 'BorderColorOutlinedIcon', bg: '#0cb969' } };
	case 'cobrar minuta':
		return { bg: '#fff', icon: { name: 'ListAlt', bg: '#eb5a46' } };
	case 'validar minuta':
		return { bg: '#fff', icon: { name: 'PlaylistAddCheck', bg: '#1781aa' } };
	case 'ligar':
		return {
			bg   : '#fff',
			icon : { name: 'HeadsetMicOutlined', bg: '#034e79' }
		};
	default:
		return { bg: '#fff', icon: { name: 'HelpOutline', bg: '#c2c3c3' } };
	}
};

export const getMaxProposal = value => {
	return value[value.length - 1];
};

export const removeSimbol = value => {
	// console.log(value)
	if ( typeof value === 'string' ) {
		let newValue = value.replace( 'R$', '' );
		newValue = newValue.replace( '.', '' );

		return newValue;
	}
	return '';
};

export const getLawyer = ( { cases, lawyerId } ) => {
	if ( cases ) {
		let processes = cases.process?.processes.sort(
			( a, b ) => new Date( b.updatedAt ) - new Date( a.updatedAt )
		);
		if ( lawyerId ) {
			return processes.find( lawyer => lawyer.lawyer_id === lawyerId )?.lawyer;
		}
		return processes.find( lawyer => lawyer.lawyer_id !== null )?.lawyer;
	}
};

export const getLawyers = cases => {
	if ( cases ) {
		const lawyer = [];
		cases.process.processes.map(
			process => process?.lawyer && lawyer.push( process.lawyer )
		);

		return lawyer;
	}
};

export const logout = unauthorized => {
	if ( unauthorized === 'unauthorized' ) {
		localStorage.removeItem( 'af-token' );
		localStorage.removeItem( 'user_id' );
		localStorage.removeItem( 'af-user' );
		localStorage.removeItem( 'redirect-url' );
		localStorage.removeItem( 'token-experip' );
		localStorage.removeItem( 'experip-token-error' );
		window.location.href = '/signin';
	}
};


export const getTokenLogin = () => {
	return localStorage.getItem( 'af-token' );
};

export const checkIsExpiredLoginToken = () => {
	const { iat, idProfileType } = jwt.decode( getTokenLogin(), 'secretkey' );

	const now = Date.now();

	const diffInMs = now - ( iat * 1000 );
	const diffInDays = Math.round( diffInMs / 86400000 );

	const days = 3;
	if ( diffInDays > days || !idProfileType ) {
		logout( 'unauthorized' );
	}
};

/**
 * Formata um número de telefone brasileiro
 * @param {string} phoneNumber - Número de telefone original (ex: "555484156656" ou "5554984156656")
 * @returns {string} - Número formatado (ex: "(54) 8415-6656" ou "(54)98415-6656")
 */
export const formatPhoneNumber = ( phoneNumber ) => {
	if ( !phoneNumber || typeof phoneNumber !== 'string' ) {
		return '';
	}

	// Remove todos os caracteres não numéricos
	const cleanNumber = phoneNumber.replace( /\D/g, '' );

	if ( cleanNumber.length === 12 ) {
		const ddd = cleanNumber.substring( 2, 4 );
		const firstPart = cleanNumber.substring( 4, 8 );
		const secondPart = cleanNumber.substring( 8 );
		return `(${ddd}) ${firstPart}-${secondPart}`;
	} else if ( cleanNumber.length === 13 ) {
		const ddd = cleanNumber.substring( 2, 4 );
		const firstPart = cleanNumber.substring( 4, 9 );
		const secondPart = cleanNumber.substring( 9 );
		return `(${ddd}) ${firstPart}-${secondPart}`;
	}

	return cleanNumber;
};

export const convertChatId = ( chatId ) => {
	if ( !chatId ) return chatId;
	const cleanNumber = chatId.replace( '@s.whatsapp.net', '' );
	if ( cleanNumber[4] === '9' && cleanNumber.length === 13 ) {
	  const convertedNumber = cleanNumber.substring( 0, 4 ) + cleanNumber.substring( 5 );
	  return convertedNumber + '@s.whatsapp.net';
	}

	if ( cleanNumber.length === 12 ) {
	  const convertedNumber = cleanNumber.substring( 0, 4 ) + '9' + cleanNumber.substring( 4 );
	  return convertedNumber + '@s.whatsapp.net';
	}
	return chatId;
};
